<div class="warning-box-wrapper">
    <div class=" warning-box {{warningBoxClass}}" data-cy="warning-box">
        <span class="warning-box-icon {{warningIconClass}}" data-cy="warning-box-icon"></span>
        <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>
</div>

<ng-template #template>
    <span class="warning-box-content" data-cy="warning-box-content">
        <ng-content></ng-content>
    </span>
</ng-template>
